import { render, staticRenderFns } from "./CvsTemplates.vue?vue&type=template&id=550224ca&scoped=true&"
import script from "./CvsTemplates.vue?vue&type=script&lang=js&"
export * from "./CvsTemplates.vue?vue&type=script&lang=js&"
import style0 from "./CvsTemplates.vue?vue&type=style&index=0&id=550224ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550224ca",
  null
  
)

export default component.exports